import dayjs from "dayjs";
import Enums from "../enums/enums";
//#region  Enum
var EnumOperator = {
  None: 0,
  Add: 1,
  Subtract: 2,
  Multiply: 3,
  Divide: 4,
};
//#endregion
//#region function
function ValidateEmail(email) {
  const reInitialCheck = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  //Check the email form before validating with the regex condition
  const emailLowerCase = String(email).toLowerCase();
  if (reInitialCheck.test(emailLowerCase)) {
    const re = /^((?!^[.])(?!.*[.]$)(?!.*[.]{2})[0-9A-Za-z]+((?!^[.])(?!.*[.]$)(?!.*[.]{2})[\w.'-]{1,64}[-!#-'*+/-9=?A-Z^-~]+)*|"([]!#-[^-~ \t]|(\\[\t -~]))+")@([0-9A-Za-z]([0-9A-Za-z-]{0,61}[0-9A-Za-z])?(\.[0-9A-Za-z]([0-9A-Za-z-]{0,61}[0-9A-Za-z])?)+|\[((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|IPv6:((((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){6}|::((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){5}|[0-9A-Fa-f]{0,4}::((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){4}|(((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):)?(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}))?::((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){3}|(((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){0,2}(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}))?::((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){2}|(((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3]):){0,3}(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}))?::(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):|(((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3]):){0,4}(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}))?::)((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3})|(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3})|(((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){0,5}(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}))?::(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3})|(((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3]):){0,6}(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}))?::)|(?!IPv6:)[0-9A-Za-z-]*[0-9A-Za-z]:[!-Z^-~]+)])$/;
    return re.test(emailLowerCase);
  } else {
    return false;
  }
}
function PeakOperator(variable1, variable2, operator) {
  var output = 0;
  variable1 = variable1.ToNumber();
  variable2 = variable2.ToNumber();
  var decimalNumberVariable1 = variable1.ToNumber().GetDecimalNumber();
  var decimalNumberVariable2 = variable2.ToNumber().GetDecimalNumber();

  var decimalNumberMax = 0;
  if (decimalNumberVariable1 !== 0 || decimalNumberVariable2 !== 0) {
    decimalNumberMax =
      decimalNumberVariable1 > decimalNumberVariable2 ? decimalNumberVariable1 : decimalNumberVariable2;
  }

  var decimalNumberDiffVariable1 =
    decimalNumberVariable2 - decimalNumberVariable1 > 0 ? decimalNumberVariable2 - decimalNumberVariable1 : 0;
  var decimalNumberDiffVariable2 =
    decimalNumberVariable1 - decimalNumberVariable2 > 0 ? decimalNumberVariable1 - decimalNumberVariable2 : 0;

  var divisorMax = Math.pow(10, decimalNumberMax);
  var divisorVariable1 = Math.pow(10, decimalNumberDiffVariable1);
  var divisorVariable2 = Math.pow(10, decimalNumberDiffVariable2);

  switch (operator) {
    case EnumOperator.Add:
      output =
        (RemoveDecimalPoint(variable1) * divisorVariable1 + RemoveDecimalPoint(variable2) * divisorVariable2) /
        divisorMax;
      break;
    case EnumOperator.Subtract:
      output =
        (RemoveDecimalPoint(variable1) * divisorVariable1 - RemoveDecimalPoint(variable2) * divisorVariable2) /
        divisorMax;
      break;
    case EnumOperator.Multiply:
      output =
        (RemoveDecimalPoint(variable1) * divisorVariable1 * RemoveDecimalPoint(variable2) * divisorVariable2) /
        (divisorMax * divisorMax);
      break;
    case EnumOperator.Divide:
      output = (RemoveDecimalPoint(variable1) * divisorVariable1) / (RemoveDecimalPoint(variable2) * divisorVariable2);
      break;
  }
  return output;
}
function RemoveDecimalPoint(variable) {
  var variableText = variable.ToNumber().toString();
  var variableResult = variableText.replace(".", "");
  return variableResult.ToNumber();
}
function PeakOperatorAdd(variable1, variable2) {
  return PeakOperator(variable1, variable2, EnumOperator.Add);
}
function PeakOperatorSubtract(variable1, variable2) {
  return PeakOperator(variable1, variable2, EnumOperator.Subtract);
}
function PeakOperatorMultiply(variable1, variable2) {
  return PeakOperator(variable1, variable2, EnumOperator.Multiply);
}
function PeakOperatorDivide(variable1, variable2) {
  return PeakOperator(variable1, variable2, EnumOperator.Divide);
}
function ToRemoveExponential(number) {
  if (Math.abs(number) < 1.0) {
    var e = parseInt(number.toString().split("e-")[1]);
    if (e) {
      number *= Math.pow(10, e - 1);
      number = "0." + new Array(e).join("0") + number.toString().substring(2);
    }
  } else {
    var e = parseInt(number.toString().split("+")[1]);
    if (e > 20) {
      e -= 20;
      number /= Math.pow(10, e);
      number += new Array(e + 1).join("0");
    }
  }
  return number;
}
function ToAccountingRoundUp(number, _decimalNumber) {
  _decimalNumber = isNaN(_decimalNumber) ? 2 : _decimalNumber;
  var negativeValue = number < 0 ? -1 : 1;
  number = number * negativeValue;
  number = number.ToRemoveExponential();
  var numberString = number.toString().split(".")[1];
  if (numberString != null && numberString.length > _decimalNumber) {
    var lastNumberDecimalToRoundUp = parseInt(numberString.substring(_decimalNumber, _decimalNumber + 1));
    var numberCalculated = parseFloat(
      number.toString().split(".")[0] + "." + numberString.substring(0, _decimalNumber + 1)
    );
    if (lastNumberDecimalToRoundUp == 5) {
      numberCalculated += 1 / Math.pow(10, _decimalNumber + 1);
    }
    numberCalculated = numberCalculated * negativeValue;
    return numberCalculated.toFixed(_decimalNumber);
  } else {
    return parseFloat(number * negativeValue).toFixed(_decimalNumber);
  }
}
function GetAmountDigit(value) {
  value = value.ToNumber().ToAccountingRoundUp(4);
  let amountDigit = 4;
  if (value.split(".")[1]) {
    let digitValue = value.split(".")[1];
    if (digitValue[3] === "0") {
      amountDigit = 3;
      if (digitValue[2] === "0") {
        amountDigit = 2;
      }
    }
  }
  return amountDigit;
}
function GetPercentAmountDigit(value) {
  value = value.ToNumber().ToAccountingRoundUp(4);
  let amountDigit = 2;
  if (value.split(".")[1]) {
    let digitValue = value.split(".")[1];
    if (digitValue[1] === "0") {
      amountDigit = 1;
      if (digitValue[2] === "0") {
        amountDigit = 0;
      }
    }
  }
  return amountDigit;
}
function StringToNumber(numberString = "") {
  let number = parseFloat(numberString.toString().replace(/,/g, ""));
  return GetNumber(number);
}
function GetNumber(number) {
  number = isNaN(number) ? 0 : number;
  return number;
}
function GetDecimalNumber(number) {
  var decimalNumber = 0;
  number = number.ToRemoveExponential();
  var numberString = number.toString().split(".")[1];
  if (numberString) {
    decimalNumber = numberString.length;
  }
  return decimalNumber;
}
function ToNumberStringFormat(amount, _decimalNumber, _deciamlSymbol, _separateSymbol) {
  var total = amount;
  var decimalNumber = isNaN((_decimalNumber = Math.abs(_decimalNumber))) ? 2 : _decimalNumber;
  var decimalSymbol = _deciamlSymbol == undefined ? "." : _deciamlSymbol;
  var separateSymbol = _separateSymbol == undefined ? "," : _separateSymbol;
  var isNegative = total.ToAccountingRoundUpNumber() < 0 ? "-" : "";
  var roundingAmount = parseInt((total = Math.abs(+total || 0).ToAccountingRoundUp(decimalNumber))) + "";
  var separateCount = (separateCount = roundingAmount.length) > 3 ? separateCount % 3 : 0;
  var decimalAmount = parseFloat(total)
    .ToAccountingRoundUp(decimalNumber)
    .split(".")[1];
  if (_decimalNumber !== 0) {
    return (
      isNegative +
      (separateCount ? roundingAmount.substr(0, separateCount) + separateSymbol : "") +
      roundingAmount.substr(separateCount).replace(/(\d{3})(?=\d)/g, "$1" + separateSymbol) +
      decimalSymbol +
      decimalAmount
    );
  } else {
    isNegative = parseInt(amount.ToAccountingRoundUpNumber()) < 0 ? "-" : "";
    return (
      isNegative +
      (separateCount ? roundingAmount.substr(0, separateCount) + separateSymbol : "") +
      roundingAmount.substr(separateCount).replace(/(\d{3})(?=\d)/g, "$1" + separateSymbol)
    );
  }
}

function NewDateTimeUctToTimezone(dateTime) {
  if (dateTime.search("Z") > -1) {
    return new Date(dateTime);
  } else {
    dateTime = dateTime + "Z";
    return new Date(dateTime);
  }
}

function ToDateTimezone(date) {
  if (typeof date === "string") {
    date = date.replace("Z", "");
    date = date.replace("z", "");
  }
  const newDate = new Date(date);
  return newDate;
}

function ToDateJsonString(date) {
  return dayjs(date).format("YYYY-MM-DDT00:00:00");
}

function GetDateFormat(date) {
  let start = new Date(date);
  let day = start.getDate().toString();
  let month = (parseInt(start.getMonth(), 10) + 1).toString();
  let year = start.getFullYear();

  day = day.length == 2 ? day : "0" + day;
  month = month.length == 2 ? month : "0" + month;

  let dateFormat = day + "/" + month + "/" + year;

  if (date == null || isNaN(day) || isNaN(month) || isNaN(year)) {
    return "";
  } else {
    return dateFormat;
  }
}

function RemoveFirstSpecialCharacterThai(text) {
  if (text) {
    let specialCharacterThaiList = ["่", "้", "๊", "๋", "ั", "็", "ิ", "่", "่ ่", "ํ", "ุ", "ู", '"', "'"];
    text = text.toString().trim();
    for (let count = 0; count < text.length; ) {
      let isHaveSpecialCharacterThai = specialCharacterThaiList.find((x) => x === text[0]);
      if (isHaveSpecialCharacterThai) {
        text = text.slice(1);
      } else {
        break;
      }
    }
  }
  return text;
}

function RegExpThai(str) {
  const RegExr = /^[ก-๙0-9$@$!%*?&#-^-_. ;:+()]+$/g;
  let text = str.toLowerCase().match(RegExr);
  return text == null ? false : true;
}

function RegExpEnglish(str) {
  const RegExr = /^[a-zA-Z0-9$@$!%*?&#-^-_. ;:+()]+$/g;
  let text = str.toLowerCase().match(RegExr);
  return text == null ? false : true;
}

function ThaiBaht(amount) {
  let bahtTxt, n;
  let bahtTH = "";
  let intValSplit = [];

  bahtTxt = amount.FormatMoney().replace(/,/g, "");
  let num = ["ศูนย์", "หนึ่ง", "สอง", "สาม", "สี่", "ห้า", "หก", "เจ็ด", "แปด", "เก้า", "สิบ"];
  let rank = ["", "สิบ", "ร้อย", "พัน", "หมื่น", "แสน", "ล้าน"];
  let temp = bahtTxt.split(".");
  let intVal = temp[0];
  let decVal = temp[1];
  if (bahtTxt.ToNumber() == 0) {
    bahtTH = "ศูนย์บาทถ้วน";
  } else {
    while (intVal) {
      let splitVal = "";
      if (intVal.length > 6) {
        splitVal = intVal.substr(intVal.length - 6, 6);
        intVal = intVal.substr(0, intVal.length - 6);
      } else {
        splitVal = intVal;
        intVal = null;
      }
      intValSplit.push(splitVal);
    }

    intValSplit.reverse();
    let intValSplitCount = intValSplit.length;

    intValSplit.forEach((value) => {
      let intcount = 0;
      for (let i = 0; i < value.length; i++) {
        n = value.substr(i, 1);
        if (n != "0") {
          if (intcount >= 1 && i == value.length - 1 && n == "1") {
            bahtTH += "เอ็ด";
          } else if (i == value.length - 2 && n == "2") {
            bahtTH += "ยี่";
          } else if (i == value.length - 2 && n == "1") {
            bahtTH += "";
          } else {
            bahtTH += num[n.ToNumber()];
          }

          bahtTH += rank[value.length - i - 1];
          intcount++;
        }
      }
      if (intValSplitCount != 1) {
        bahtTH += rank[6];
      }
      intValSplitCount--;
    });

    if (bahtTH.trim().length > 0) {
      bahtTH += "บาท";
    }
    if (decVal == "00") {
      if (bahtTH.trim().length > 0) {
        bahtTH += "ถ้วน";
      }
    } else {
      let deccount = 0;

      for (let i = 0; i < decVal.length; i++) {
        n = decVal.substr(i, 1);
        if (n != "0") {
          if (deccount >= 1 && i == decVal.length - 1 && n == "1") {
            bahtTH += "เอ็ด";
          } else if (i == decVal.length - 2 && n == "2") {
            bahtTH += "ยี่";
          } else if (i == decVal.length - 2 && n == "1") {
            bahtTH += "";
          } else {
            bahtTH += num[n.ToNumber()];
          }
          bahtTH += rank[decVal.length - i - 1];
          deccount++;
        }
      }
      bahtTH += "สตางค์";
    }
  }

  return bahtTH;
}

function IsTaxNumber(taxIdNumber) {
  if (taxIdNumber && taxIdNumber.length == 13) {
    let sum = 0;
    for (let i = 0; i < taxIdNumber.length - 1; i++) {
      let n = parseInt(taxIdNumber[i]);
      sum = sum + (13 - i) * n;
    }
    let resultSum = (11 - (sum % 11)) % 10;
    let checkSum = parseInt(taxIdNumber[12]);
    return resultSum == checkSum;
  }
  return false;
}

function FormatBankNumber(bankNumber) {
  let bankNumberFormat = "";
  const lastIndex = bankNumber.length - 1;
  for (let i = 0; i <= lastIndex; i++) {
    if ((i == 2 || i == 3 || i == 8) && i != lastIndex) {
      bankNumberFormat += bankNumber[i] + "-";
    } else {
      bankNumberFormat += bankNumber[i];
    }
  }
  return bankNumberFormat;
}

export const UrlCombine = (uri, ...segments) => {
  if (!uri || !uri.trim()) {
    return null;
  }

  const normalizedBase = uri.endsWith("/") ? uri.slice(0, -1) : uri;
  const normalizedSegments = segments.map((segment) =>
    segment ? (segment.trim().startsWith("/") ? segment.slice(1).trim() : segment.trim()) : ""
  );

  return `${normalizedBase}/${normalizedSegments.join("/")}`;
};
//#endregion
//#region  extension function
String.prototype.UrlCombine = function(...segments) {
  return UrlCombine(this, ...segments);
};
String.prototype.IsTaxNumber = function() {
  return IsTaxNumber(this);
};
String.prototype.RegExpThai = function() {
  return RegExpThai(this);
};
String.prototype.RegExpEnglish = function() {
  return RegExpEnglish(this);
};
Number.prototype.PeakEncryption = function() {
  return btoa(this);
};
String.prototype.PeakEncryption = function() {
  return btoa(this);
};
String.prototype.PeakDecryption = function() {
  let value = 0;
  try {
    value = atob(this).ToNumber();
  } catch {
    value = 0;
  }
  return value;
};
Number.prototype.ToThaiBaht = function() {
  return ThaiBaht(this);
};
Number.prototype.ToRemoveExponential = function() {
  return ToRemoveExponential(this);
};
Number.prototype.ToAccountingRoundUp = function(_decimalNumber) {
  return ToAccountingRoundUp(this, _decimalNumber);
};
String.prototype.ToAccountingRoundUp = function(_decimalNumber) {
  return ToAccountingRoundUp(parseFloat(Number(this)), _decimalNumber);
};
String.prototype.ToAccountingRoundUpNumber = function(_decimalNumber) {
  return parseFloat(ToAccountingRoundUp(parseFloat(this.ToNumber()), _decimalNumber));
};
Number.prototype.ToAccountingRoundUpNumber = function(_decimalNumber) {
  return parseFloat(ToAccountingRoundUp(this, _decimalNumber));
};
String.prototype.ToNumber = function() {
  return StringToNumber(this);
};
Number.prototype.ToNumber = function() {
  return GetNumber(this);
};
Number.prototype.ToPeakTransactionItemFormat = function() {
  let value = this;
  let digitAmount = GetAmountDigit(value);
  return value.FormatMoney(digitAmount);
};
Number.prototype.ToPercentFormat = function() {
  let value = this;
  let digitAmount = GetPercentAmountDigit(value);
  return value.FormatMoney(digitAmount);
};
String.prototype.ValidateEmail = function() {
  return ValidateEmail(this);
};
String.prototype.ValidateEmailMerchant = function() {
  return ValidateEmailMerchant(this);
};
String.prototype.ToPeakTransactionItemFormat = function() {
  let value = this;
  value = value.ToNumber();
  let digitAmount = GetAmountDigit(value);
  return value.FormatMoney(digitAmount);
};
String.prototype.ToPercentFormat = function() {
  let value = this;
  value = value.ToNumber();
  let digitAmount = GetPercentAmountDigit(value);
  return value.FormatMoney(digitAmount);
};
String.prototype.FormatMoney = function(_decimalNumber, _deciamlSymbol, _separateSymbol) {
  let number = this;
  number = number.ToNumber();
  return ToNumberStringFormat(number, _decimalNumber, _deciamlSymbol, _separateSymbol);
};
Number.prototype.FormatMoney = function(_decimalNumber, _deciamlSymbol, _separateSymbol) {
  return ToNumberStringFormat(this, _decimalNumber, _deciamlSymbol, _separateSymbol);
};
String.prototype.PeakFormatMoney = function(decimalNumber) {
  if (decimalNumber == undefined) {
    decimalNumber = 2;
  }
  const value = this.ToAccountingRoundUpNumber(decimalNumber);
  if (parseInt(value) < 0) {
    return "(" + ToNumberStringFormat(value * -1, decimalNumber, ".", ",") + ")";
  } else {
    return ToNumberStringFormat(value, decimalNumber, ".", ",");
  }
};
Number.prototype.PeakFormatMoney = function(decimalNumber) {
  if (decimalNumber == undefined) {
    decimalNumber = 2;
  }
  const value = this.ToAccountingRoundUpNumber(decimalNumber);
  if (parseInt(value) < 0) {
    return "(" + ToNumberStringFormat(value * -1, decimalNumber, ".", ",") + ")";
  } else {
    return ToNumberStringFormat(value, decimalNumber, ".", ",");
  }
};
Number.prototype.GetDecimalNumber = function() {
  return GetDecimalNumber(this);
};
Number.prototype.Add = function(variable) {
  return PeakOperatorAdd(this, variable);
};
Number.prototype.Subtract = function(variable) {
  return PeakOperatorSubtract(this, variable);
};
Number.prototype.Multiply = function(variable) {
  return PeakOperatorMultiply(this, variable);
};
Number.prototype.Divide = function(variable) {
  return PeakOperatorDivide(this, variable);
};
String.prototype.ToDateJsonString = function() {
  return ToDateJsonString(this);
};
Date.prototype.ToDateJsonString = function() {
  return ToDateJsonString(this);
};
String.prototype.NewDateTimeUctToTimezone = function() {
  return NewDateTimeUctToTimezone(this);
};
String.prototype.ToDateTimezone = function() {
  return ToDateTimezone(this);
};
Date.prototype.GetDateFormat = function() {
  return GetDateFormat(this);
};
String.prototype.GetDateFormat = function() {
  return GetDateFormat(this);
};
Number.prototype.IsSuccess = function() {
  return this === Enums.HttpStatusCode.OK;
};
String.prototype.IsSuccess = function() {
  return this.ToNumber() === Enums.HttpStatusCode.OK;
};
Number.prototype.IsNoContent = function() {
  return this === Enums.HttpStatusCode.NoContent;
};
String.prototype.IsNoContent = function() {
  return this.ToNumber() === Enums.HttpStatusCode.NoContent;
};
Number.prototype.GetKeyByValue = function(object) {
  return Object.keys(object).find((key) => object[key] === this);
};
String.prototype.FormatBankNumber = function() {
  return FormatBankNumber(this);
};

//#endregion
export default {
  PeakOperatorAdd(variable1, variable2) {
    return PeakOperator(variable1, variable2, EnumOperator.Add);
  },
  PeakOperatorSubtract(variable1, variable2) {
    return PeakOperator(variable1, variable2, EnumOperator.Subtract);
  },
  PeakOperatorMultiply(variable1, variable2) {
    return PeakOperator(variable1, variable2, EnumOperator.Multiply);
  },
  PeakOperatorDivide(variable1, variable2) {
    return PeakOperator(variable1, variable2, EnumOperator.Divide);
  },
  StringToNumber(string) {
    return StringToNumber(string);
  },
  ToAccountingRoundUp(amount, decimal = 2) {
    return ToAccountingRoundUp(amount, decimal);
  },
  GetAmountDigit(amount = 0) {
    return GetAmountDigit(amount);
  },
  RemoveFirstSpecialCharacterThai(text) {
    return RemoveFirstSpecialCharacterThai(text);
  },
};
